// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";

function get(values, field) {
  switch (field) {
    case "Quantity" :
      return values.quantity;
    case "SenderVariantId" :
      return values.senderVariantId;
    case "RecipientVariantId" :
      return values.recipientVariantId;
  }
}

function set(values, field, value) {
  switch (field) {
    case "Quantity" :
      return {
        quantity: value,
        senderVariantId: values.senderVariantId,
        recipientVariantId: values.recipientVariantId
      };
    case "SenderVariantId" :
      return {
        quantity: values.quantity,
        senderVariantId: value,
        recipientVariantId: values.recipientVariantId
      };
    case "RecipientVariantId" :
      return {
        quantity: values.quantity,
        senderVariantId: values.senderVariantId,
        recipientVariantId: value
      };
  }
}

let ProductLenses = {
  get: get,
  set: set
};

function get$1(values, field) {
  switch (field) {
    case "SenderShopId" :
      return values.senderShopId;
    case "RecipientShopId" :
      return values.recipientShopId;
    case "Products" :
      return values.products;
  }
}

function set$1(values, field, value) {
  switch (field) {
    case "SenderShopId" :
      return {
        senderShopId: value,
        recipientShopId: values.recipientShopId,
        products: values.products
      };
    case "RecipientShopId" :
      return {
        senderShopId: values.senderShopId,
        recipientShopId: value,
        products: values.products
      };
    case "Products" :
      return {
        senderShopId: values.senderShopId,
        recipientShopId: values.recipientShopId,
        products: value
      };
  }
}

let Lenses_ = {
  get: get$1,
  set: set$1
};

let Lenses = {
  get: get$1,
  set: set$1
};

let initialValues_products = [];

let initialValues = {
  senderShopId: "",
  recipientShopId: "",
  products: initialValues_products
};

let include = Form.Make(Lenses);

function productsError(products) {
  return Stdlib_Array.filterMap(products, product => {
    if (product.quantity <= 0) {
      return {
        key: product.senderVariantId,
        message: I18n.t("Transferred quantity must be greater than 0.")
      };
    }
  });
}

let schema = [
  {
    TAG: "StringNotEmpty",
    _0: "SenderShopId"
  },
  {
    TAG: "StringNotEmpty",
    _0: "RecipientShopId"
  },
  {
    TAG: "Custom",
    _0: "Products",
    _1: param => {
      if (param.products.length === 0) {
        return {
          TAG: "Error",
          _0: I18n.t("You should have at least one product in cart.")
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "Products",
    _1: param => {
      if (productsError(param.products).length !== 0) {
        return {
          TAG: "Error",
          _0: I18n.t("The cart contains products with an incorrect transferred quantity.")
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }
];

let Core = include.Core;

let Schema = include.Schema;

let FormLegacyProvider = include.FormLegacyProvider;

let FormProvider = include.FormProvider;

let InputText = include.InputText;

let InputSuggestionComboBox = include.InputSuggestionComboBox;

let InputSelect = include.InputSelect;

let InputToggleButtonGroup = include.InputToggleButtonGroup;

let InputCountrySelect = include.InputCountrySelect;

let InputTextArea = include.InputTextArea;

let InputPassword = include.InputPassword;

let InputNumber = include.InputNumber;

let InputOptionalNumber = include.InputOptionalNumber;

let InputRadioGroup = include.InputRadioGroup;

let InputRadioCardGroup = include.InputRadioCardGroup;

let InputPhone = include.InputPhone;

let InputCheckbox = include.InputCheckbox;

let InputToggleSwitch = include.InputToggleSwitch;

let InputDate = include.InputDate;

let InputOptionalDate = include.InputOptionalDate;

let InputOptionalDateFastNav = include.InputOptionalDateFastNav;

let InputDateRange = include.InputDateRange;

let CancelButton = include.CancelButton;

let SubmitButton = include.SubmitButton;

let ControlEnterKey = include.ControlEnterKey;

let AutoSave = include.AutoSave;

let useFormPropState = include.useFormPropState;

let useField = include.useField;

let useFormState = include.useFormState;

let useFormDispatch = include.useFormDispatch;

let validate = include.validate;

let isValidField = include.isValidField;

export {
  ProductLenses,
  Lenses_,
  Lenses,
  initialValues,
  Core,
  Schema,
  FormLegacyProvider,
  FormProvider,
  InputText,
  InputSuggestionComboBox,
  InputSelect,
  InputToggleButtonGroup,
  InputCountrySelect,
  InputTextArea,
  InputPassword,
  InputNumber,
  InputOptionalNumber,
  InputRadioGroup,
  InputRadioCardGroup,
  InputPhone,
  InputCheckbox,
  InputToggleSwitch,
  InputDate,
  InputOptionalDate,
  InputOptionalDateFastNav,
  InputDateRange,
  CancelButton,
  SubmitButton,
  ControlEnterKey,
  AutoSave,
  useFormPropState,
  useField,
  useFormState,
  useFormDispatch,
  validate,
  isValidField,
  productsError,
  schema,
}
/* include Not a pure module */
